import React from "react";
import { useNavigate } from "react-router-dom";

export function ReferenceLink({ value }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation(); // Stop row click navigation
    let mockId = "1";
    const ref = value || "";
    if (ref.includes("ALC-0028") || ref.includes("8899")) {
      mockId = "2";
    } else if (ref.includes("ALC-0025") || ref.includes("0112")) {
      mockId = "3";
    } else if (ref.includes("ALC-0026") || ref.includes("7756")) {
      mockId = "4";
    }
    navigate(`/inventory-management/allocation-detail/${mockId}`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-xs font-bold text-[var(--color-primary)] hover:underline cursor-pointer focus:outline-none bg-transparent border-0 p-0 text-left font-mono"
    >
      {value}
    </button>
  );
}
